<ng-container [ngSwitch]="flavor$ | async">
  <!-- RATEL flavor -->

  <ng-container *ngSwitchCase="menuFlavors.RATEL">
    <header class="nt-header nt-header--ratel">
      <div class="nt-wrapper">
        <a [routerLink]="logoLink" class="nt-logo">
          <img
            [src]="logoPath$ | async"
            [alt]="logoAlt"
            width="64"
            height="64"
          />
        </a>
        <a [routerLink]="logoLink" class="nt-logo nt-logo--alt">
          <img [src]="logoSidePath$ | async" [alt]="logoAlt" />
        </a>
        <button class="nt-hamburger" (click)="sidenav.toggle()" mat-icon-button>
          <mat-icon *ngIf="!sidenav?.opened">menu</mat-icon>
          <mat-icon *ngIf="sidenav?.opened">close</mat-icon>
        </button>
      </div>
      <div class="nt-wrapper nt-wrapper--sub">
        <div class="nt-wrapper">
          <nt-main-nav
            *ngIf="menu$ | async as menu"
            className="nt-header__nav"
            [menu]="menu"
          ></nt-main-nav>
          <nt-language-selector
            className="nt-header__select"
          ></nt-language-selector>
        </div>
      </div>
    </header>
  </ng-container>

  <!-- Defaul flavor -->

  <ng-container *ngSwitchDefault>
    <header class="nt-header">
      <div class="nt-wrapper">
        <a [routerLink]="logoLink" class="nt-logo">
          <img
            [src]="logoPath$ | async"
            [alt]="logoAlt"
            width="64"
            height="64"
          />
        </a>
        <nt-main-nav
          *ngIf="menu$ | async as menu"
          className="nt-header__nav"
          [menu]="menu"
        ></nt-main-nav>
        <nt-language-selector
          className="nt-header__select"
        ></nt-language-selector>
        <button class="nt-hamburger" (click)="sidenav.toggle()" mat-icon-button>
          <mat-icon *ngIf="!sidenav?.opened">menu</mat-icon>
          <mat-icon *ngIf="sidenav?.opened">close</mat-icon>
        </button>
      </div>
    </header>
  </ng-container>
</ng-container>
